// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credits-blocked-dialog.p-dialog {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(250, 115, 23, 0.12), 0 8px 16px rgba(0, 0, 0, 0.06);
}

.credits-blocked-dialog .p-dialog-content {
  padding: 0;
  border-radius: 16px;
  background: #fff;
}

.credits-blocked-dialog .p-dialog-header-icons {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1;
}

.credits-blocked-dialog .p-dialog-header-icon {
  width: 2rem;
  height: 2rem;
  color: #9ca3af;
  border-radius: 50%;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.credits-blocked-dialog .p-dialog-header-icon:hover {
  background: #fff7ed;
  color: #fa7317;
}

.credits-blocked-modal {
  padding: 2.25rem 1.75rem 1.75rem;
  text-align: center;
  font-family: Inter, sans-serif;
}

.credits-blocked-modal__logo {
  height: 48px;
  width: auto;
  margin-bottom: 1.5rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.credits-blocked-modal__message {
  margin: 0 0 1.75rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
}

.credits-blocked-modal__btn.p-button {
  width: 100%;
  justify-content: center;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: 8px;
  padding: 0.7rem 1rem;
  background: #fa7317 !important;
  border: 1px solid #fa7317 !important;
  color: #fff !important;
  box-shadow: none !important;
  outline: none !important;
}

.credits-blocked-modal__btn.p-button:hover {
  background: #e56610 !important;
  border-color: #e56610 !important;
  box-shadow: none !important;
}

.credits-blocked-modal__btn.p-button:focus,
.credits-blocked-modal__btn.p-button:focus-visible,
.credits-blocked-modal__btn.p-button:active,
.credits-blocked-modal__btn.p-button.p-focus {
  background: #fa7317 !important;
  border-color: #fa7317 !important;
  box-shadow: none !important;
  outline: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/CreditsBlockedModal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;;;EAIE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,wBAAwB;AAC1B","sourcesContent":[".credits-blocked-dialog.p-dialog {\n  border: none;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 24px 48px rgba(250, 115, 23, 0.12), 0 8px 16px rgba(0, 0, 0, 0.06);\n}\n\n.credits-blocked-dialog .p-dialog-content {\n  padding: 0;\n  border-radius: 16px;\n  background: #fff;\n}\n\n.credits-blocked-dialog .p-dialog-header-icons {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 1;\n}\n\n.credits-blocked-dialog .p-dialog-header-icon {\n  width: 2rem;\n  height: 2rem;\n  color: #9ca3af;\n  border-radius: 50%;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.credits-blocked-dialog .p-dialog-header-icon:hover {\n  background: #fff7ed;\n  color: #fa7317;\n}\n\n.credits-blocked-modal {\n  padding: 2.25rem 1.75rem 1.75rem;\n  text-align: center;\n  font-family: Inter, sans-serif;\n}\n\n.credits-blocked-modal__logo {\n  height: 48px;\n  width: auto;\n  margin-bottom: 1.5rem;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.credits-blocked-modal__message {\n  margin: 0 0 1.75rem;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #374151;\n}\n\n.credits-blocked-modal__btn.p-button {\n  width: 100%;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.95rem;\n  border-radius: 8px;\n  padding: 0.7rem 1rem;\n  background: #fa7317 !important;\n  border: 1px solid #fa7317 !important;\n  color: #fff !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.credits-blocked-modal__btn.p-button:hover {\n  background: #e56610 !important;\n  border-color: #e56610 !important;\n  box-shadow: none !important;\n}\n\n.credits-blocked-modal__btn.p-button:focus,\n.credits-blocked-modal__btn.p-button:focus-visible,\n.credits-blocked-modal__btn.p-button:active,\n.credits-blocked-modal__btn.p-button.p-focus {\n  background: #fa7317 !important;\n  border-color: #fa7317 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
